import { Form } from "antd";
import FormSwitch from "component/form/form_switch";
import React, { useState } from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const WithdrawSavebank = () => {
  // -------------------------- VAR -----------------------------
  const form = Form?.useFormInstance();
  const code = Form?.useWatch("code", form) || null;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!code) return null;
  return (
    <FormSwitch label="Lưu vào danh bạ" name="saveBank" initialValue={true} />
  );
};
export default WithdrawSavebank;
